module.exports = __webpack_public_path__ + "img/about_us_1.e4c466ed.jpg";